import { Icon } from "@chakra-ui/react";
import { FaTelegram } from "react-icons/fa6";

import { NavButton, NavButtonProps } from "./nav-button";

import { PLUME_TG_URL } from "@/constants/shared";

export const TgButton = (props: Omit<NavButtonProps, "href">) => (
  <NavButton
    variant="ghost"
    href={PLUME_TG_URL}
    target="_blank"
    p={0}
    {...props}
  >
    <Icon boxSize={6} color="fg.muted">
      <FaTelegram />
    </Icon>
  </NavButton>
);
